import { List, Misc } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../../App/Models/NotificationDuration';
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import CreateLetterAuthorisationBatchCommand from '../../../Models/LetterAuthorisation/Commands/CreateLetterAuthorisationBatchCommand';
import LetterAuthorisationBatchCriteria from '../../../Models/LetterAuthorisation/Commands/LetterAuthorisationBatchCriteria';
import LetterAuthorisationBatchLookup from '../../../Models/LetterAuthorisation/Lookups/LetterAuthorisationBatchLookup';

export default class NewAuthorisationBatchVM extends Views.ViewModelBase {

    constructor(
        public criteria: LetterAuthorisationBatchCriteria,
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private apiClient = AppService.get(DomainTypes.ApiClients.LetterAuthorisation),
        public dataCache = AppService.get(DomainTypes.Services.DataCache)) {

        super(taskRunner);
        this.makeObservable();

        criteria.forNewBatch = true;

        this.criteriaAutoRunner = this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.fetchSuggestedBatchDates()));
    }

    public criteriaAutoRunner: Misc.IAutoRunner;

    public suggested = new List(LetterAuthorisationBatchLookup);

    public createCommand: CreateLetterAuthorisationBatchCommand | null = null;

    public async initialise() {
        this.fetchSuggestedBatchDates();
    }

    public async fetchSuggestedBatchDates() {
        if (this.criteria.isValid && this.criteria.reportType) {

            const data = await this.taskRunner.waitForData(this.apiClient.getSuggestedBatchDates(this.criteria.toQueryObject()));
            this.suggested.set(data);
        }
    }

    public beginCreateAuthorisationBatch(lookup: LetterAuthorisationBatchLookup) {
        this.createCommand = new CreateLetterAuthorisationBatchCommand(this.criteria, lookup);
    }

    public createAuthorisationBatch(command: CreateLetterAuthorisationBatchCommand) {
        return this.taskRunner.run(async () => {

            const result = await this.apiClient.createLetterAuthorisationBatch(command.toJSObject());
            this.notifications.addSuccess("Authorisation Batch", "Authorisation batch created successfully.", NotificationDuration.Standard);

            return result.data;
        });
    }
}